// @ts-check

import StoreRegistry from 'infrastructure/js/utils/StoreRegistry';

import Network from '../../../../infrastructure/js/modules/network';
import * as itemCommentsService from '../../services/ItemComments/itemCommentsService.js';
import DateTimeHelper from 'infrastructure/js/utils/dateTimeHelper';
// import { createLabelHelper } from 'infrastructure/js/utils/labelHelper';

import { api as messageDialogApi } from '../../actions/MessageDialog/messageDialogActions.js';

import { api as schedulerGanttPageApi } from '../../actions/SchedulerPage/schedulerGanttPageActions.js';

import { staticApi as schedulerOperationsGridStaticApi } from '../../actions/SchedulerPage/schedulerOperationsGridActions.js';
import { staticApi as locationTaskGridStaticApi } from '../../actions/LocationPage/TasksView/tasksGridActions.js';


/**
 * @typedef {import("../../types/PL_ReduxTypes").ReduxDispatch} ReduxDispatch
 * @typedef {import("../../types/PL_ReduxTypes").ReduxGetState} ReduxGetState
 * 
 * @typedef {import("../../types/PL_ReduxTypes").PL_FullState} PL_FullState
 * 
 * 
 * @typedef {import('mat/js/components/Dialogs/ItemCommentsDialog/ItemCommentDialogTypes').NewCommentSubmitData} NewCommentSubmitData
 * @typedef {import('mat/js/components/Dialogs/ItemCommentsDialog/ItemCommentDialogTypes').ShowCommentsParams} ShowCommentsParams
 * @typedef {import('mat/js/components/Dialogs/ItemCommentsDialog/ItemCommentDialogTypes').ItemComment} ItemComment
 * @typedef {import('mat/js/components/Dialogs/ItemCommentsDialog/ItemCommentDialogTypes').ItemCommentType} ItemCommentType
 * 
 * @typedef {import('mat/js/types/ServerTypes/Models/ItemComments').AddTaskCommentRequestModel} AddTaskCommentRequestModel
 * @typedef {import('mat/js/types/ServerTypes/Models/ItemComments').TaskProgressCommentDto} TaskProgressCommentDto
 * 
 * 
 */




export const actionTypes = {
  ITEM_COMMENTS_DIALOG__SHOW: 'ITEM_COMMENTS_DIALOG__SHOW',
  ITEM_COMMENTS_DIALOG__HIDE: 'ITEM_COMMENTS_DIALOG__HIDE',

  ITEM_COMMENTS_DIALOG__BUSY: 'ITEM_COMMENTS_DIALOG__BUSY',
  ITEM_COMMENTS_DIALOG__READY: 'ITEM_COMMENTS_DIALOG__READY',

  ITEM_COMMENTS_DIALOG__SET_DATA: 'ITEM_COMMENTS_DIALOG__SET_DATA',
  ITEM_COMMENTS_DIALOG__SET_ITEM_INFO: 'ITEM_COMMENTS_DIALOG__SET_ITEM_INFO',

  ITEM_COMMENTS_DIALOG__SET_LAST_COMMENT_SAVED_ON: 'ITEM_COMMENTS_DIALOG__SET_LAST_COMMENT_SAVED_ON',


};

const actions = {

  show: function () {
    return { type: actionTypes.ITEM_COMMENTS_DIALOG__SHOW };
  },
  hide: function () {
    return { type: actionTypes.ITEM_COMMENTS_DIALOG__HIDE };
  },

  busy: function () {
    return { type: actionTypes.ITEM_COMMENTS_DIALOG__BUSY };
  },
  ready: function () {
    return { type: actionTypes.ITEM_COMMENTS_DIALOG__READY };
  },

  /**
   * @param {ItemComment[]} data
   */
  setData: function (data) {
    return { type: actionTypes.ITEM_COMMENTS_DIALOG__SET_DATA, payload: data };
  },

  /**
   * @param {{ itemId: number, itemType: ItemCommentType, itemDisplayName?: string | '--UNCHANGED--'}} data
   */
  setItemInfo: function (data) {
    return { type: actionTypes.ITEM_COMMENTS_DIALOG__SET_ITEM_INFO, payload: data };
  },

  signalLastCommentSaved: function () {
    return { type: actionTypes.ITEM_COMMENTS_DIALOG__SET_LAST_COMMENT_SAVED_ON };
  },

};



export let jsxActions = {};


export let api = {};


/**
 * @param {NewCommentSubmitData} data
 * 
 */
api.submitAddComment = async function (data) {
  let { dispatch, getState } = StoreRegistry.getDefaultStore();


  /** @type {AddTaskCommentRequestModel} */
  let requestModel = {
    taskId: data.itemId,
    comment: data.comment,
  };

  let response = await itemCommentsService.addTaskComment(requestModel);
  if (!Network.isResponseValid(response)) {
    console.error('Add Comment Failed');
    messageDialogApi.responseError(dispatch, getState)(response);
    return;
  }


  api.displayCommentsForItem({
    itemId: data.itemId,
    itemType: data.itemType,
  });

  // This is used to clear the input field in the comments dialog.
  api.signalLastCommentSaved();


  api.notifyCommentAdded(data.itemId);
  
};

/**
 * @param {number} itemId
 */
api.notifyCommentAdded = function (itemId) {

  // @ts-ignore
  schedulerGanttPageApi.markEventHasComments(itemId);
  
  schedulerOperationsGridStaticApi.onCommentAdded(itemId); 
  locationTaskGridStaticApi.onCommentAdded(itemId);
  
}



/**
 * @param {ShowCommentsParams} params
 */
api.displayCommentsForItem = async function (params) {
  let { dispatch, getState } = StoreRegistry.getDefaultStore();

  api.show();
  api.setBusy();
  api.setItemInfo(params);

  /** * @type {ItemComment[]} */
  let comments = [];
  try {

    comments = await fetchComments(params);
    // comments = addDebugComments(comments);

  } catch (error) {
    console.error('Error loading comments:', error);
    api.setReady();



    return;
  }


  api.setData(comments);
  api.setReady();

};


api.show = function () {
  let { dispatch, getState } = StoreRegistry.getDefaultStore();

  dispatch(actions.show());

};
api.hide = function () {
  let { dispatch, getState } = StoreRegistry.getDefaultStore();

  dispatch(actions.hide());

};

api.setBusy = function () {
  let { dispatch, getState } = StoreRegistry.getDefaultStore();

  dispatch(actions.busy());

};

api.setReady = function () {
  let { dispatch, getState } = StoreRegistry.getDefaultStore();

  dispatch(actions.ready());

};


/** 
 * @param {ItemComment[]} clientComments
 */
api.setData = function (clientComments) {
  let { dispatch, getState } = StoreRegistry.getDefaultStore();

  dispatch(actions.setData(clientComments));

};


/**
 * @param {ShowCommentsParams} params
 */
api.setItemInfo = function (params) {
  let { dispatch, getState } = StoreRegistry.getDefaultStore();

  // console.log('setItemInfo params ===> ', params); 
  dispatch(
    actions.setItemInfo({
      itemId: params.itemId,
      itemType: params.itemType,
      itemDisplayName: params.itemDisplayName || '--UNCHANGED--',
    }));
}


api.signalLastCommentSaved = function () {
  let { dispatch, getState } = StoreRegistry.getDefaultStore();
  
  dispatch(actions.signalLastCommentSaved());
  
};



///////////////////////////////////////////////////////////
// Helper functions



/**
 * @param {ShowCommentsParams} params
 */
let fetchComments = async function (params) {

  if (params.itemType === 'SCHEDULER_TASK') {
    return await fetchCommentsForSchedulerTask(params);
  }

  throw new Error('Unsupported item type for fetching comments: ' + params.itemType);

}

/**
 * @param {ShowCommentsParams} params
 */
let fetchCommentsForSchedulerTask = async function (params) {
  let { dispatch, getState } = StoreRegistry.getDefaultStore();

  let commentsResponse = await itemCommentsService.getTaskComments({
    taskId: params.itemId,
  });

  if (!Network.isResponseValid(commentsResponse)) {
    messageDialogApi.responseError(dispatch, getState)(commentsResponse);
    throw new Error('Loading comments failed');
  }


  let serverComments = commentsResponse?.dataList || [];
  let clientComments = serverComments.map((comment) => {
    return transformToClientComment(comment);
  });

  let sortedClientComments = clientComments.sort((a, b) => b.createdDateEpoch - a.createdDateEpoch);


  return sortedClientComments;

}



/**
 * @param {TaskProgressCommentDto} serverComment
 * 
 * @returns {ItemComment} 
 * 
 */
let transformToClientComment = function (serverComment) {

  let timeISO = serverComment.createdDate;
  let time = new Date(timeISO);

  let timeEpoch = time.getTime();

  // let timeString_SIMPLE = time.toLocaleDateString() + ' ' + time.toLocaleTimeString();
  // console.log('timeEpoch ===> ', timeEpoch + ' timeString_SIMPLE ===> ', timeString_SIMPLE);
  // let timeString = DateTimeHelper.DateTimeFormat(timeEpoch);
  let timeString = DateTimeHelper.DateTimeFormatAsIs(timeEpoch);


  /** @type {ItemComment} */
  let result = {

    id: serverComment.id,

    // itemId: serverComment.itemId,
    // itemDisplayName: serverComment.itemDisplayName,

    comment: serverComment.comment,
    createdByUser: serverComment.createdByUser,

    createdDateString: timeString,
    createdDateEpoch: timeEpoch,

  };

  return result;
};






////////////////////////////////////////////////////////////////////
// Debugging and development helpers


// // DEV DEBUG
// // @ts-ignore
// if (__DEV__) {
//   window.SRR = StoreRegistry;
//   window.AA = api;
// }





